import { Badge } from '@/components/ui/badge';
import { getStudentStatusLabel } from '@/lib/student-utils';

import { StudentStatus } from '@airreading/common/data';

import clsx from 'clsx';

const StudentStatusColorMap = {
  [StudentStatus.enrolled]: 'bg-green-400 hover:bg-green-400',
  [StudentStatus.dropped]: 'bg-orange-500 hover:bg-orange-500',
  [StudentStatus.program_concluded]: 'bg-gray-300 hover:bg-gray-300',
};

export interface StudentStatusBadgeProps {
  status: StudentStatus | null | undefined;
}

export const StudentStatusBadge = ({ status }: StudentStatusBadgeProps) => {
  const label = getStudentStatusLabel(status);
  return status ? (
    <Badge className={clsx([StudentStatusColorMap[status], 'text-secondary-foreground whitespace-nowrap'])}>
      {label}
    </Badge>
  ) : (
    label
  );
};
